/* === CLAUDE-SHOPIFY-CHANGE-024-START | Kart renk galerisi (2026-10-09) === */
if (!customElements.get('woolona-color-gallery')) {
  class WoolonaColorGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('.wcg__track');
      this.slides = [...this.querySelectorAll('.wcg__slide')];
      this.bars = [...this.querySelectorAll('.wcg__bar i')];
      this.label = this.querySelector('.wcg__label');
      this.card = this.closest('card-product');
      this.links = this.card ? [...this.card.querySelectorAll('a.card-product__media, a.card-product__content')] : [];
      this.swatchInputs = this.card ? [...this.card.querySelectorAll('.js-swatches input[data-color]')] : [];
      this.touch = window.matchMedia('(hover: none)');
      this.base = 0;
      this.index = -1;
      if (this.card) this.card.classList.add('has-wcg');

      this.querySelectorAll('.wcg__zones span').forEach((z, i) => {
        z.addEventListener('mouseenter', () => this.show(i));
      });
      this.addEventListener('mouseleave', () => { if (!this.touch.matches) this.show(this.base); });

      this.track.addEventListener('scroll', () => {
        if (!this.touch.matches) return;
        cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => {
          const w = this.track.clientWidth || 1;
          const i = Math.round(this.track.scrollLeft / w);
          if (i !== this.index) { this.base = i; this.show(i); this.flash(); }
        });
      }, { passive: true });

      const swatches = this.card && this.card.querySelector('.js-swatches');
      if (swatches) {
        swatches.addEventListener('change', e => {
          const c = e.target && e.target.dataset ? e.target.dataset.color : null;
          if (!c) return;
          const i = this.slides.findIndex(s => s.dataset.color === c);
          if (i < 0) return;
          this.base = i;
          this.show(i);
          if (this.touch.matches) this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
        });
      }
      this.show(0);
    }

    show(i) {
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      if (i === this.index) return;
      this.index = i;
      const slide = this.slides[i];
      this.slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      this.bars.forEach((b, n) => b.classList.toggle('is-active', n === i));
      if (this.label) this.label.textContent = slide.dataset.color || '';
      const vid = slide.dataset.variant;
      if (vid) this.links.forEach(a => { a.href = a.href.split('?')[0] + '?variant=' + vid; });
      this.swatchInputs.forEach(inp => inp.classList.toggle('wcg-current', inp.dataset.color === slide.dataset.color));
    }

    flash() {
      this.classList.add('is-swiped');
      clearTimeout(this._t);
      this._t = setTimeout(() => this.classList.remove('is-swiped'), 1400);
    }
  }
  customElements.define('woolona-color-gallery', WoolonaColorGallery);
}
/* === CLAUDE-SHOPIFY-CHANGE-024-END === */
